import { useCallback, useState } from "react";

// Small helper to add drag-and-drop file support to any element while
// keeping the existing click-to-choose <input type=file>. Returns a
// `dragging` flag (for highlight styling) and props to spread on the drop area.
export function useFileDrop(onFiles, { disabled = false } = {}) {
  const [dragging, setDragging] = useState(false);

  const onDragOver = useCallback((e) => { e.preventDefault(); }, []);
  const onDragEnter = useCallback((e) => {
    e.preventDefault();
    if (!disabled) setDragging(true);
  }, [disabled]);
  const onDragLeave = useCallback((e) => {
    e.preventDefault();
    // only clear when leaving the drop area itself, not a child
    if (e.currentTarget.contains(e.relatedTarget)) return;
    setDragging(false);
  }, []);
  const onDrop = useCallback((e) => {
    e.preventDefault();
    setDragging(false);
    if (disabled) return;
    const files = e.dataTransfer?.files;
    if (files && files.length) onFiles(files);
  }, [onFiles, disabled]);

  return { dragging, dropProps: { onDragOver, onDragEnter, onDragLeave, onDrop } };
}
